// extracted by mini-css-extract-plugin
export default {"editable":"H1_editable__J9o6+","editWrapper":"H1_editWrapper__Wec-q","moveButtonUp":"H1_moveButtonUp__dGdJJ","moveButtonDown":"H1_moveButtonDown__xOlGM","text":"H1_text__hQiRW"};